import { formatDateToDDMMYYYY } from '#utils/date';
import { takeNCharacters } from '#utils/string';

import { MAX_WEEK } from './constants';

export const getMondayOfTheYear = (date, number) => {
  // Copy d if provided
  const aDate = date ? date : new Date();
  // Set to start of month
  aDate.setDate(1);
  // Store end year and month
  const endYear = aDate.getFullYear() + 1;
  const endMonth = aDate.getMonth();
  // Set to first Monday
  aDate.setDate(aDate.getDate() + (8 - ((aDate.getDay() || 7) % 7)));
  const mondays = [new Date(Number(aDate))];
  // Create Dates for all Mondays up to end year and month
  while (aDate.getFullYear() < endYear || aDate.getMonth() !== endMonth) {
    mondays.push(new Date(aDate.setDate(aDate.getDate() + 7)));
  }
  return takeNCharacters(10)(mondays[(number - 1) % MAX_WEEK]?.toISOString());
};

export const getDateFromDateAndTime = dateAndTime =>
  dateAndTime ? formatDateToDDMMYYYY(dateAndTime.slice(0, -6)) : '';

export const formatProductDate = dateAndTime => {
  const takeCharacters = takeNCharacters(10);
  return dateAndTime ? formatDateToDDMMYYYY(takeCharacters(dateAndTime)) : '';
};
